import { cn } from "@utils/tw"

export const GridBreakout = ({
  amount = 2,
  children,
  className,
}: {
  amount?: number
  children: React.ReactNode
  className?: string
}) => {
  const widths: { [key: number]: string } = {
    0: "w-full",
    1: "md:w-[calc(100%+(var(--tw-grid-col-width)*2+var(--tw-grid-gutter)))]",
    2: "md:w-[calc(100%+(var(--tw-grid-col-width)*4+var(--tw-grid-gutter)*2))]",
    3: "md:w-[calc(100%+(var(--tw-grid-col-width)*6+var(--tw-grid-gutter)*4))]",
    4: "md:w-[calc(100%+(var(--tw-grid-col-width)*8+var(--tw-grid-gutter)*6))]",
  }
  const offsets: { [key: number]: string } = {
    0: "",
    1: "md:ml-[calc(-1*(var(--tw-grid-col-width)))]",
    2: "md:ml-[calc(-1*(var(--tw-grid-col-width)*2+var(--tw-grid-gutter)))]",
    3: "md:ml-[calc(-1*(var(--tw-grid-col-width)*3+var(--tw-grid-gutter)*2))]",
    4: "md:ml-[calc(-1*(var(--tw-grid-col-width)*4+var(--tw-grid-gutter)*3))]",
  }

  return <div className={cn(className, widths[amount], offsets[amount])}>{children}</div>
}
